import React, { useEffect, useReducer } from "react";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import ChooseLocation from "./components/ChooseLocation/ChooseLocation";
import CustomerInformation from "./components/CustomerInformation/CustomerInformation";
import ItemCategory from "./components/ItemCategory/ItemCategory";
import MapModal from "./components/MapModal/MapModal";
import Style from "./DeliverRequest.module.css";
import { separate } from "./../../Seprate/Seprate";
import { calculateDeliveryPriceApi } from "../../Api/DeliveryServices";
import { errorToast } from "../../Toast/Toast";
import { useHistory } from "react-router-dom";
import DeliveryBottomNavigation from "./components/DeliveryBottomNavigation/DeliveryBottomNavigation"
// Reducer function
const initialState = {
  secondDestination: false,
  showModal: false,
  currentField: "",
  origin: null,
  destination: null,
  destination2: null,
  categoryItemKey: "0",
  selectedLocation: "",
  calculatedPrice: null,
  loadingState: false,
  senderInfo:"",
  resiverInfo:"",
  resiver2Info:"",
  typedCategory:"",
  productDescription:"",
};

function reducer(state, action) {
  switch (action.type) {
    case "TOGGLE_SECOND_DESTINATION":
      return { ...state, secondDestination: !state.secondDestination };
    case "OPEN_MODAL":
      console.log("OPEN_MODAL dispatched with field:", action.field);
      return { ...state, showModal: true, currentField: action.field };
    case "SET_SENDER_INFORMATION":
      return { ...state, senderInfo:action.payload };
    case "SET_RESIVER_INFORMATION":
      return { ...state, resiverInfo:action.payload };
    case "SET_RESIVER2_INFORMATION":
      return { ...state, resiver2Info:action.payload };
    case "CLOSE_MODAL":
      return { ...state, showModal: false };
    case "SET_LOCATION":
      return { ...state, [action.field]: action.location, showModal: false };
    case "SET_CATEGORY_KEY":
      return { ...state, categoryItemKey: action.key };
    case "SET_SELECTED_LOCATION":
      return { ...state, selectedLocation: action.location };
    case "SET_CALCULATED_PRICE":
      return { ...state, calculatedPrice: action.payload };
    case "SET_LOADING":
      return { ...state, loadingState: action.payload };
    case "SET_INSERT_CATEGORY":
      return { ...state, typedCategory: action.payload };
    case "SET_PRODUCT_DESCRIPTION":
      return { ...state, productDescription: action.payload };
    default:
      return state;
  }
}

const DeliverRequest = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const history=useHistory()
  const calculatedPriceHandler = (info) => {
    dispatch({ type: "SET_LOADING", payload: true });
    calculateDeliveryPriceApi(info, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          dispatch({
            type: "SET_CALCULATED_PRICE",
            payload: res.delivery_price.delivery,
          });
          dispatch({ type: "SET_LOADING", payload: false });
        } else {
          errorToast(res.message);
          dispatch({ type: "SET_LOADING", payload: false });
          dispatch({
            type: "SET_LOCATION",
            field: "origin",
            location:null,
          })
        }
      } else {
        console.error(res);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    });
  };

  const calculatePriceValidation = () => {
    if (
      state.destination &&
      state.origin &&
      state.secondDestination &&
      state.destination2
    ) {
      const info = {
        routes: [
          state.origin.location,
          state.destination.location,
          state.destination2.location,
        ],
      };
      calculatedPriceHandler(info);
    } else if (!state.secondDestination && state.destination && state.origin) {
      const info = {
        routes: [state.origin.location, state.destination.location],
      };
      calculatedPriceHandler(info);
    }
  };
  useEffect(() => {
    calculatePriceValidation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.destination,
    state.origin,
    state.destination2,
    state.secondDestination,
  ]);
  const validationHandler = () => {
    const validations = [
      { condition: !state.origin, message: "لطفا مبدا را مشخص کنید!" },
      { condition: !state.destination, message: "لطفا مقصد را مشخص کنید!" },
      { condition: state.secondDestination && !state.destination2, message: "لطفا مقصد دوم را مشخص کنید!" },
  
      { condition: !state.senderInfo, message: "لطفا اطلاعات فرستنده را وارد کنید!" },
      { condition: !state.senderInfo?.senderName, message: "لطفا نام و نام خانوادگی فرستنده را وارد کنید!" },
      { condition: !state.senderInfo?.senderPhone, message: "لطفا شماره تماس فرستنده را وارد کنید!" },
  
      { condition: !state.resiverInfo, message: "لطفا اطلاعات گیرنده را وارد کنید!" },
      { condition: !state.resiverInfo?.resiverName, message: "لطفا نام و نام خانوادگی گیرنده را وارد کنید!" },
      { condition: !state.resiverInfo?.resiverPhone, message: "لطفا شماره تماس گیرنده را وارد کنید!" },
  
      { condition: state.secondDestination && !state.resiver2Info, message: "لطفا اطلاعات گیرنده دوم را وارد کنید!" },
      { condition: state.secondDestination && !state.resiver2Info?.resiver2Name, message: "لطفا نام و نام خانوادگی گیرنده دوم را وارد کنید!" },
      { condition: state.secondDestination && !state.resiver2Info?.resiver2Phone, message: "لطفا شماره تماس گیرنده دوم را وارد کنید!" },
  
      { condition: state.categoryItemKey === "0", message: "لطفا یک دسته بندی را انتخاب کنید!" },
      { condition: state.categoryItemKey === "12" && !state.typedCategory, message: "لطفا دسته بندی موردنظر را وارد کنید!" },
      { condition: !state.productDescription, message: "لطفاوزن و اندازه مرسوله را وارد کنید!" },
    ];
  
    for (const { condition, message } of validations) {
      if (condition) {
        errorToast(message);
        return;
      }
    }
    history.push({pathname:'/submitdeliveryrequest',state:state})
  };
  return (
    <div className={Style.pageHolder}>
      <BurgerMenuTitle title="پیک" />

      <ChooseLocation
        secondDestinationState={state.secondDestination}
        dispatch={dispatch}
        originLocation={state.origin}
        destinationLocation={state.destination}
        destination2Location={state.destination2}
      />

      <CustomerInformation secondDestinationState={state.secondDestination} dispatch={dispatch}/>

      <ItemCategory
        categoryItemKey={state?.categoryItemKey}
        dispatch={dispatch}
        setCategoryItemKey={(key) =>
          dispatch({ type: "SET_CATEGORY_KEY", key })
        }
      />

      <DeliveryBottomNavigation />

      {state.showModal&&<MapModal
        DeliverState={state}
        onSelectLocation={(location) =>
          dispatch({
            type: "SET_LOCATION",
            field: state.currentField,
            location,
          })
        }
        closeModal={() => dispatch({ type: "CLOSE_MODAL" })}
      />}
      <div className={Style.SubmitButtonHolder}>
        {state.calculatedPrice && (
          <>
            {state.loadingState ? (
              <b>در حال محاسبه</b>
            ) : (
              <b>{`${separate(state.calculatedPrice)} تومان`}</b>
            )}
            <span>|</span>
          </>
        )}
        <button disabled={state.loadingState} onClick={validationHandler}>ثبت درخواست</button>
      </div>
    </div>
  );
};

export default DeliverRequest;
